import { Link } from 'react-router-dom';

const categories = [
  {
    id: 'storage',
    title: 'Storage Spaces',
    icon: 'ri-home-4-line',
    items: ['Garages', 'Sheds', 'Basements', 'Carports', 'Backyards'],
    color: 'bg-blue-600',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20Australian%20garage%20interior%20with%20organised%20storage%20space%2C%20empty%20and%20well-lit%20with%20concrete%20floor%20and%20white%20walls%2C%20professional%20real%20estate%20photography%20showing%20spacious%20storage%20area%20with%20natural%20lighting%20and%20minimal%20clutter%2C%20suburban%20home%20setting&width=600&height=400&seq=cat-storage-001&orientation=landscape'
  },
  {
    id: 'vehicle',
    title: 'Vehicle Spaces',
    icon: 'ri-car-line',
    items: ['Car parking', 'Caravan parking', 'Boat parking', 'Motorcycle storage', 'Airport parking', 'Long-term Parking'],
    color: 'bg-blue-600',
    image: 'https://readdy.ai/api/search-image?query=Australian%20suburban%20driveway%20with%20car%20parking%20space%2C%20clean%20concrete%20surface%20with%20modern%20home%20in%20background%2C%20bright%20daylight%20showing%20secure%20parking%20area%20with%20fence%20and%20gate%2C%20professional%20real%20estate%20photography%20with%20clear%20blue%20sky&width=600&height=400&seq=cat-vehicle-002&orientation=landscape'
  },
  {
    id: 'garage',
    title: 'Garage Space',
    icon: 'ri-home-gear-line',
    items: ['Meeting rooms', 'Studios', 'Workshops', 'Hobby rooms', 'Classrooms'],
    color: 'bg-blue-600',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Australian%20home%20studio%20space%20with%20natural%20lighting%2C%20clean%20white%20walls%20and%20wooden%20floors%2C%20empty%20room%20ready%20for%20creative%20activities%20with%20large%20windows%2C%20professional%20interior%20photography%20showing%20versatile%20workspace%20with%20minimal%20furniture&width=600&height=400&seq=cat-activity-003&orientation=landscape'
  },
  {
    id: 'jetty-pontoon-boat',
    title: 'Jetty/Pontoon/Boat Spaces',
    icon: 'ri-ship-line',
    items: ['Jetty/Pontoon Berth', 'Boat storage', 'Jet ski parking', 'Marina berths', 'Trailer parking', 'Watercraft storage'],
    color: 'bg-blue-600',
    image: 'https://readdy.ai/api/search-image?query=White%20speedboat%20moored%20at%20private%20residential%20timber%20pontoon%20jetty%20in%20backyard%20canal%20waterway%2C%20luxury%20Australian%20waterfront%20home%20with%20manicured%20lawn%20extending%20to%20water%20edge%2C%20Gold%20Coast%20Sunshine%20Coast%20Queensland%20canal%20estate%20lifestyle%2C%20neighboring%20canal%20homes%20visible%20along%20peaceful%20waterway%2C%20bright%20sunny%20day%20with%20calm%20reflective%20water%2C%20contemporary%20architecture%20house%20behind%20private%20boat%20dock%2C%20exclusive%20residential%20marina%20berth%20setting%2C%20professional%20real%20estate%20photography%20showcasing%20premium%20waterfront%20living%20with%20personal%20boat%20mooring%20facility&width=600&height=400&seq=jetty-residential-goldcoast-v5&orientation=landscape'
  },
  {
    id: 'caravan',
    title: 'Caravan Spaces',
    icon: 'ri-truck-line',
    items: ['Caravan parking', 'RV storage', 'Motorhome spaces', 'Camper storage', 'Long-term parking'],
    color: 'bg-blue-600',
    image: 'https://readdy.ai/api/search-image?query=Spacious%20Australian%20caravan%20parking%20area%20with%20wide%20concrete%20driveway%2C%20secure%20fencing%20and%20gate%20access%2C%20suburban%20setting%20with%20modern%20home%20in%20background%2C%20professional%20real%20estate%20photography%20showing%20safe%20and%20convenient%20RV%20storage%20space%20with%20clear%20blue%20sky&width=600&height=400&seq=cat-caravan-005&orientation=landscape'
  },
  {
    id: 'land',
    title: 'Land/Acreage',
    icon: 'ri-landscape-line',
    items: ['Open land', 'Acreage rental', 'Farm storage', 'Equipment parking', 'Outdoor storage'],
    color: 'bg-blue-600',
    image: 'https://readdy.ai/api/search-image?query=Australian%20open%20land%20acreage%20with%20green%20grass%20and%20clear%20space%20for%20storage%2C%20rural%20setting%20with%20fencing%20and%20trees%20in%20background%2C%20bright%20daylight%20showing%20spacious%20outdoor%20area%20suitable%20for%20equipment%20and%20vehicle%20storage%2C%20professional%20landscape%20photography%20with%20blue%20sky&width=600&height=400&seq=cat-land-006&orientation=landscape'
  }
];

export default function Categories() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Explore Categories
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Find the perfect space or asset for your needs, or list what you have to earn extra income
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/browse?category=${category.id}`}
              className="group bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={category.image}
                  alt={category.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                />
                <div className={`absolute top-4 left-4 w-12 h-12 ${category.color} rounded-xl flex items-center justify-center shadow-lg`}>
                  <i className={`${category.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                  {category.title}
                </h3>
                <ul className="space-y-2">
                  {category.items.map((item, index) => (
                    <li key={index} className="flex items-center text-gray-600 text-sm">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
